import {SvgIcon} from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import "./MainSidebar.scss";
import {NavLink, useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import Authorized from "../../utils/auth/Authorized";
import {VivoPortal} from "@utils/AppConstants";
import EnumMemberGroupAliases = VivoPortal.EnumMemberGroupAliases;
import {useTranslation} from "react-i18next";

export default function MainSidebar() {
    const {lng} = useParams<{ lng: string }>();
    const {t} = useTranslation();
    return (
        <div className={"sidebar-wrapper"}>
            <nav className={"sidebar"}>
                <ul>
                    <Authorized roleMask={EnumMemberGroupAliases.User}>
                        <li key={"index"}>
                            <NavLink to={`/${lng}/orders/edit`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.plusCircleIcon} size="xlarge"/>
                                <span className="title">{t("ORDER_NEW_ORDER")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.User}>
                        <li key={"index1"}>
                            <NavLink to={`/${lng}/orders`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.listUnorderedIcon} size="xlarge"/>
                                <span className="title">{t("NAV_OrderList")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.SuperAdmin | EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.Supervisor}
                        labFilter={[1, 11]}>
                        <li key={"index2"}>
                            <NavLink to={`/${lng}/projects`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.listUnorderedIcon} size="xlarge"/>
                                <span className="title">{t("NAV_ProjectList")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin | EnumMemberGroupAliases.Supervisor}>
                        <li key={"index1aaz"}>
                            <NavLink to={`/${lng}/recipes`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.grayscaleIcon} size="xlarge"/>
                                <span className="title">{t("PAGE_TITLE_RECIPE_LIST")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.SuperAdmin | EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.Supervisor | EnumMemberGroupAliases.Employee}>
                        <li key={"index1bb"}>
                            <NavLink to={`/${lng}/customers`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.cartIcon} size="xlarge"/>
                                <span className="title">{t("NAV_CUST_MANAGEMENT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.User}
                                labFilter={[1, 11]}>
                        <li key={"index3"}>
                            <NavLink to={`/${lng}/files`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faPaperclip} size="xl"/>
                                <span className="title">{t("NAV_MyFiles")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin}>
                        <li key={"index7"}>
                            <NavLink to={`/${lng}/components`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faDroplet} size="xl"/>
                                <span className="title">{t("NAV_COMPONENTS")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.SuperAdmin | EnumMemberGroupAliases.Admin}>
                        <li key={"index1aa"}>
                            <NavLink to={`/${lng}/users`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.userIcon} size="xlarge"/>
                                <span className="title">{t("NAV_USER_MANAGEMENT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.User}>
                        <li key={"index1js"}>
                            <NavLink to={`/${lng}/charts/job-statistics`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.chartAreaRangeIcon} size="xlarge"/>
                                <span className="title">{t("NAV_JOB_STAT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.User}>
                        <li key={"index1js"}>
                            <NavLink to={`/${lng}/charts/jobs-percentage`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.percentIcon} size="xlarge"/>
                                <span className="title">{t("NAV_JOB_PERCENT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.SuperAdmin | EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.Supervisor}>
                        <li key={"index1js"}>
                            <NavLink to={`/${lng}/charts/delay-statistics`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.clockIcon} size="xlarge"/>
                                <span className="title">{t("NAV_DELAY_STAT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.User}>
                        <li key={"index1js111"}>
                            <NavLink to={`/${lng}/reports/order-list-report`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.reportElementIcon} size="xlarge"/>
                                <span className="title">Order List Report</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.Admin}>
                        <li key={"index1js111"}>
                            <NavLink to={`/${lng}/reports/csv-reports`}>
                                <SvgIcon className={"nav-icon"} icon={svgIcons.fileCsvIcon} size="xlarge"/>
                                <span className="title">{t("REPORTS_CSV")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.Admin} labFilter={[1]} divisionFilter={[1]}>
                        <li key={"index1js111q"}>
                            <NavLink to={`/${lng}/reports/brand-color-report`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faBahai} size="xl"/>
                                <span className="title">{t("NAV_BRAND_COLOR_REPORT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.Admin} labFilter={[1]} divisionFilter={[1]}>
                        <li key={"index1js111q"}>
                            <NavLink to={`/${lng}/charts/rft-chart`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faCalculator} size="xl"/>
                                <span className="title">{t("NAV_RFT_MARS_REPORTS")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.Supervisor}>
                        <li key={"index1js111q"}>
                            <NavLink to={`/${lng}/job-assignment-list`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faAnchor} size="xl"/>
                                <span className="title">{t("NAV_JOBS_ASSIGNMENT_LIST")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin}>
                        <li key={"index6"}>
                            <NavLink to={`/${lng}/email-list`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faMailBulk} size="xl"/>
                                <span className="title">{t("NAV_SYSTEM_MAILING")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin}>
                        <li key={"index6"}>
                            <NavLink to={`/${lng}/laboratories`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faMapLocationDot} size="xl"/>
                                <span className="title">{t("NAV_LAB_MANAGEMENT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin}>
                        <li key={"index6aa"}>
                            <NavLink to={`/${lng}/drop-down-list-management`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faRectangleList} size="xl"/>
                                <span className="title">{t("NAV_DROPDOWNLIST_MANAGEMENT")}</span>
                            </NavLink>
                        </li>
                    </Authorized>
                    <Authorized
                        roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin} labFilter={[1, 2, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]}>
                        <li key={"index311a"}>
                            <NavLink to={`/${lng}/product-codes`}>
                                <FontAwesomeIcon className={"nav-icon"} icon={icons.faBarcode} size="xl"/>
                                <span className="title">{t("NAV_CODES")}</span>
                            </NavLink>
                        </li>
                    </Authorized>

                   
                    {/*<Authorized*/}
                    {/*    roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin | EnumMemberGroupAliases.Supervisor}>*/}
                    {/*    <li key={"index6"}>*/}
                    {/*        <NavLink to={`/${lng}/work-evaluation-list`}>*/}
                    {/*            <FontAwesomeIcon className={"nav-icon"} icon={icons.faBusinessTime} size="xl"/>*/}
                    {/*            <span className="title">{t("NAV_WORK_EVAL")}</span>*/}
                    {/*        </NavLink>*/}
                    {/*    </li>*/}
                    {/*</Authorized>*/}
                    
                    {/*<Authorized*/}
                    {/*    roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin}>*/}
                    {/*    <li key={"index6"}>*/}
                    {/*        <NavLink to={`/${lng}/email-group-list`}>*/}
                    {/*            <FontAwesomeIcon className={"nav-icon"} icon={icons.faObjectUngroup} size="xl"/>*/}
                    {/*            <span className="title">{t("lblEmailGroups")}</span>*/}
                    {/*        </NavLink>*/}
                    {/*    </li>*/}
                    {/*</Authorized>*/}
                    {/*<Authorized*/}
                    {/*    roleMask={EnumMemberGroupAliases.Admin | EnumMemberGroupAliases.SuperAdmin}>*/}
                    {/*    <li key={"index6"}>*/}
                    {/*        <NavLink to={`/${lng}/ink-series`}>*/}
                    {/*            <FontAwesomeIcon className={"nav-icon"} icon={icons.faPalette} size="xl"/>*/}
                    {/*            <span className="title">{t("NAV_INK_SERIES")}</span>*/}
                    {/*        </NavLink>*/}
                    {/*    </li>*/}
                    {/*</Authorized>*/}
                    {/*/!*<li>*!/*/}
                    {/*    <hr/>*/}
                    {/*</li>*/}
                    <li>
                        <hr/>
                    </li>
                    
                    {/*<li key={"index4"}>*/}
                    {/*    <a href={`/${lng}/`}>*/}
                    {/*        <SvgIcon className={"nav-icon"} icon={svgIcons.plusCircleIcon} size="xlarge"/>*/}
                    {/*        <span className="title">Chart</span>*/}
                    {/*    </a>*/}
                    {/*</li>*/}
                    {/*<li key={"index5"}>*/}
                    {/*    <a href={`/${lng}/`}>*/}
                    {/*        <SvgIcon className={"nav-icon"} icon={svgIcons.listUnorderedIcon} size="xlarge"/>*/}
                    {/*        <span className="title">Reports</span>*/}
                    {/*    </a>*/}
                    {/*</li>*/}
                    <li>
                        <hr/>
                    </li>
                    <li>
                        <hr/>
                    </li>
                </ul>
            </nav>
        </div>
    )
}